import { Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import LoaderCircle from 'src/pages/LoaderCircle'
import { ManageSubUsersStatus } from '../config'
import { useEffect, useState } from 'react'

const PartnerRoute = ({ element: Component, path, ...rest }) => {
  const user = useSelector((state) => state.user)
  const { permissions = {} } = useSelector(
    (state) => state.whiteLabelTeamMemberStatus || {}
  )
  const [isChecked, setIsChecked] = useState(false)
  const [isAllowed, setIsAllowed] = useState(undefined)

  useEffect(() => {

    if (!user) return

    const allPermissionsEmpty = Object.values(permissions).every(
      (val) => val === false || val === 'None'
    )

    if (user.isTeamMember && allPermissionsEmpty) {
      console.log('Permissions not yet updated, waiting...')
      return
    }

    let allowed = true

    if (user.isTeamMember) {
      switch (path) {
        case 'manage-users':
          allowed =
            permissions.manageSubUsers === ManageSubUsersStatus.ALL ||
            permissions.manageSubUsers === ManageSubUsersStatus.ASSIGNED
          break
        case 'branding-management':
          allowed = permissions.manageBranding === true
          break
        case 'plans':
          allowed = permissions.managePlans === true
          break
        case 'team-management':
          allowed = permissions.manageTeamMembers === true
          break
        default:
          allowed = true
      }

      setIsAllowed(allowed)
      setIsChecked(true)
    } else {
      setIsAllowed(true)
      setIsChecked(true)
    }
  }, [path, permissions, user])

  if (!isChecked || !user) {
    return <LoaderCircle />
  }

  if (isChecked && (!user.isWhiteLabelUser || !isAllowed)) {
    return <Navigate to="/accounts" />
  } else if (isChecked) {
    return <Component {...rest} />
  }
  return null
}

export default PartnerRoute
